import { fetchBills } from 'admin/actions/bills';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import Button from 'admin/components/shared/Button';
import { toQueryParams } from 'admin/utils';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '../../../hooks/useApp';
import { selectUserPrivateMoney } from '../../../reducers/user-private-money';
import Headings from '../../atoms/Headings';
import UserPrivateMoneyNotAllowed from '../../atoms/UserPrivateMoneyNotAllowed';
import SelectedPrivateMoneyDisplay from '../../organisms/SelectedPrivateMoneyDisplay';
import FilterForm from './FilterForm';
import ListTable from './ListTable';

const FormWrapper = styled.div``;

const Row = styled.div`
  padding: 10px 0;
`;

const LabelText = styled.div`
  font-weight: 600;
`;

const SearchResultInfo = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
`;
const SearchResultTitle = styled(Headings.h5)`
  margin: 0;
  margin-left: 15px;
  padding: 16px 0;
`;
const SearchResultCount = styled.span`
  flex: 1;
`;

const Bills = () => {
  const crumbs = [
    { value: 'ホーム', href: '/', isCurrentPage: false },
    { value: '販促管理', href: '', isCurrentPage: true },
    { value: '支払いQRコード管理', href: '', isCurrentPage: true },
  ];

  const [filterParams, setFilterParams] = useState(null);
  const [bills, setBills] = useState(null);

  const user = useAppSelector((state) => state.user);
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);
  const issuedMoneys = user.issuedMoneys();
  const allowedPrivateMoneys = user.isServiceUser()
    ? user.privateMoneys
    : issuedMoneys.length !== 0
    ? issuedMoneys
    : user.moneys();
  const isSelectedMoneyAllowed = allowedPrivateMoneys.some(
    (money) => money.id === userPrivateMoney.id
  );

  const onChangePage = (page) => {
    fetchBills(toQueryParams({ page, ...filterParams }, true)).then((b) => {
      setBills(b);
    });
  };

  const applyFilters = (params) => {
    setFilterParams(params);
    fetchBills(toQueryParams({ page: 1, ...params }, true)).then((b) => {
      setBills(b);
    });
  };

  return (
    <FormWrapper>
      <BreadCrumb crumbs={crumbs} />
      {!isSelectedMoneyAllowed && (
        <>
          <SelectedPrivateMoneyDisplay
            highlightHeader
            allowedPrivateMoneys={allowedPrivateMoneys}
          />
          <UserPrivateMoneyNotAllowed />
        </>
      )}
      {isSelectedMoneyAllowed && (
        <>
          <Row>
            <Link to="/promotion/bills/create">
              <Button type="button">支払いQRコードを新規発行</Button>
            </Link>
          </Row>
          <LabelText>検索条件</LabelText>
          <FilterForm applyFilters={applyFilters} />
          <SearchResultInfo>
            <SearchResultTitle>検索結果</SearchResultTitle>
            {bills !== null && <SearchResultCount>件数：{bills?.count ?? 0}</SearchResultCount>}
          </SearchResultInfo>
          {bills != null ? (
            <ListTable
              bills={bills.rows}
              pagination={bills.pagination}
              onChangePage={onChangePage}
            />
          ) : null}
          <p>QRコードは株式会社デンソーウェーブの登録商標です</p>
        </>
      )}
    </FormWrapper>
  );
};

export default Bills;
